import { render, staticRenderFns } from "./My_Nickname.vue?vue&type=template&id=54537953&scoped=true"
import script from "./My_Nickname.vue?vue&type=script&lang=js"
export * from "./My_Nickname.vue?vue&type=script&lang=js"
import style0 from "./My_Nickname.vue?vue&type=style&index=0&id=54537953&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54537953",
  null
  
)

export default component.exports